<template>
  <div class="white-rounded-box mb-7">
    <div class="mx-7 mt-6">
      <div class="flex justify-between">
        <h2 class="text-lg md:text-xl mb-2">My Customers</h2>
        <button
              class="tooltip"
              type="button"
              @click.prevent="goToInvitePage"
              title="Invite contacts"
            >
              <div class="flex items-center hover:cursor-pointer">
                <svg-vue
                    icon="plus-solid"
                    title="Invite contacts"
                    class="h-6 hover:cursor-pointer self-center"
                />
              </div>
              <div class="tooltiptext hover:cursor-pointer">Invite contacts</div>
        </button>
      </div>
      <a
        v-if="data.length > 5"
        class="text-lg md:text-xl hover:cursor-pointer text-salesium-bronze hover:text-salesium-bronze hover:opacity-50"
        aria-label="View all customers"
        @click.prevent="openAllCustomersModal"
      >View all ({{ data.length }})</a>
      <!-- <a class="text-lg md:text-xl mb-3" aria-label="View all customers">View all ({{pros.length}})</a> -->
    </div>
    <div class="border-t mt-3">
      <div class="text-lg font-bold mt-3 ml-7">Top Customers</div>
      <!-- TODO: loop through customers -->
      <Customer
        v-for="customer in data.splice(0,5)"
        :customer="customer"
        :key="customer.id"
        v-on:openCustomerModal="openCustomerModal"
        v-on:openPingModal="openPingModal"
      />
    </div>
  </div>
</template>

<script>
import Customer from './Customer.vue';
export default {
    props: ['data'],
    methods: {
      openAllCustomersModal(){
        this.$emit('openAllCustomersModal', 'customer');
      },
      openCustomerModal(customer) {
       // this.$emit('openCustomerModal', customer); // disable until we need it
      },
      openPingModal(customer){
        this.$emit('openPingModal', customer);
      },
      goToInvitePage(){
          window.location = "/invite-contacts";
      }
    },
    components: {
        Customer,
    },
};
</script>
<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  opacity: 0;
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  transition-property: opacity;
  transition-duration: 0.7s;
  opacity: 1;
  visibility: visible;
}
</style>
